"use client"

import { useState } from "react"
import { Bar, BarChart, LabelList, ResponsiveContainer, XAxis } from "recharts"
import { chartConfig } from "@/config/charts"
import { cn } from "@/lib/utils"
import {
  ChartConfig,
  ChartContainer,
  ChartLegend,
  ChartLegendContent,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/ui/chart"

interface BarChartStackedProps {
  data: any
  config?: ChartConfig
  className?: string
}

export function BarChartStacked({
  data,
  config,
  className,
}: BarChartStackedProps) {
  const [hiddenKeys, setHiddenKeys] = useState<string[]>([])

  const keys = Object.keys(data[0] || {}).filter((key) => key !== "date")

  //console.log(keys)

  const handleLegendClick = (event: any) => {
    const key = event.dataKey
    setHiddenKeys((prev) =>
      prev.includes(key) ? prev.filter((item) => item !== key) : [...prev, key],
    )
  }

  return (
    <ChartContainer
      config={config ? config : chartConfig}
      className={cn("aspect-16/9 mx-auto h-[40dvh] w-full", className)}
    >
     {/*  <ResponsiveContainer width="100%" height="100%"> */}
        <BarChart data={data}>
          <XAxis
            dataKey="date"
            tickLine={false}
            tickMargin={5}
            axisLine={false}
            tick={{ fontWeight: "bold" }} // Makes date labels bold
            tickFormatter={(value) =>
              new Date(value).toLocaleDateString("en-US", {
                year: "numeric",
                month: "short",
                day: "numeric",
              })
            }
          />
          <ChartTooltip
            content={<ChartTooltipContent />}
            labelFormatter={(label) =>
              new Date(label).toLocaleDateString("en-US", {
                year: "numeric",
                month: "short",
                day: "numeric",
              })
            }
          />

          <ChartLegend
            content={<ChartLegendContent />}
            onClick={handleLegendClick}
          />
          {keys.map((key, index) => {
            // Remove spaces from the key
            const sanitizedKey = key.trim().replace(/\s+/g, "")

            return (
              <Bar
                key={key}
                dataKey={key}
                stackId="a"
                hide={hiddenKeys.includes(key)}
                fill={`var(--color-${sanitizedKey})`}
                radius={index === keys.length - 1 ? [4, 4, 0, 0] : [0, 0, 0, 0]}
              >
                {/* Display values inside bars */}
                <LabelList dataKey={key} position="center" fill="white" />
              </Bar>
            )
          })}
        </BarChart>
      {/* </ResponsiveContainer> */}
    </ChartContainer>
  )
}
